/**
 * Axios configuration with automatic token handling
 * Supports both cookies (primary) and localStorage (fallback for mobile)
 */
import axios from 'axios';

// Create axios instance with default config
const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true, // Always send cookies
  timeout: 30000, // 30 second timeout
});

// Request interceptor - add Authorization header from localStorage if available
api.interceptors.request.use(
  (config) => {
    // Check if we have a stored token (mobile fallback)
    const storedToken = localStorage.getItem('wtpl_session_token');
    if (storedToken && !config.headers['Authorization']) {
      config.headers['Authorization'] = `Bearer ${storedToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // If we get a 401, clear the stored token
    if (error.response?.status === 401) {
      localStorage.removeItem('wtpl_session_token');
    }
    return Promise.reject(error);
  }
);

export default api;

// Also export raw axios for cases where we need direct access
export { axios };
